import { render, staticRenderFns } from "./BestProductsTable.vue?vue&type=template&id=6f975cec&"
import script from "./BestProductsTable.vue?vue&type=script&lang=js&"
export * from "./BestProductsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports